import Vue from "vue";

import SecondChanceDetail from "./SecondChanceDetail.vue";

export function load() {
    const selector = "second-chance-promotion";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(SecondChanceDetail, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
